import { PermissionsEnum } from '@/auth/interfaces';

export const SAVE_CLIENTE_CONTRATO_PERMISSIONS = [
  PermissionsEnum.api_view_contrato,
  PermissionsEnum.api_change_contrato,
  PermissionsEnum.api_add_contrato,
];
